/* Add close button Jun 18, 2023 */
/* Add check-circle,actualMin,actualMax  to filter icon Oct 7, 2023 */
/* Amend m_countActiveFilters  Jan 20, 2024 */
/* Add searchBar  Oct 5, 2024 */
/* Add "border:none" to table-filter May 10, 2025 */
/* Add if(this.d_activeFilters[key]) to watch Aug 16, 2025 */
/* Add route query Parameters, p_filters prop/watch Sep 6, 2025 */
/* Amend toggleFilters bug Sep 13, 2025 */
/* Amended mounted, addd data to filters,watch for p_filters from popup Table Oct 25, 2025 */
/* Bug fix of typo in localstorage of filter,default p_filters Nov 1, 2025 */
<template>
    <div>
        <b-dropdown right  toggle-class="table-filter d-flex" menu-class="filter-dropdown">
			<template #button-content> 
                <span class="icon" >
                    <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clip-rule="evenodd"></path>
						<title>Filters</title>
                    </svg>
                </span>
                   <fa-icon :icon="['fas', 'check-circle']" transform="up-2 right-2" v-show="c_currentFilter" />
            </template>
			<span  @click="m_closeWindow" class="topright-close">&times;</span>
			<div class="filter-dropdown--header"> 
				<h3>Filters</h3>
			</div>
			<div class="searchBar">
				<b-input id="searchBar" class="input-search" v-model="d_search" type="search" placeholder="Search" size=50 ></b-input>
				<fa-icon v-if="!d_search" icon="search" />
			</div>
            <template v-if="p_filterData === null"> 
                <p class="px-4 ">No filters are available</p>
            </template>
            <template v-else> 
                <div v-if="isLoading">
                    <skeleton-filter />
                </div>
                <div class="filter-dropdown--content" v-else>
                    <filter-accordion 
						v-for="(value, property, index) in c_filterData"
                        :p_title="value.name" :p_property="property"  
                        :key="`${index}-${value.name}-field`"
                    >
                        <div v-if="value.data.length>0" class="filter-selection" :class="{'range': value.range, 'date': value.date}">
                            <template v-if="value.date"> 
                                <filter-range 
                                    :field="property"
                                    dataType='date'
                                    min=null
                                    max=null
									:actualMin="value.actualMin"
									:actualMax="value.actualMax"
                                    :fromDate="value.min"
                                    :toDate="value.max"
                                    @onChange="handleRange"
                                />
                            </template >
                            <template v-else-if="value.range"> 
                                <filter-range 
                                    :field="property"
                                    dataType='number'
                                    :min="value.min"
                                    :max="value.max"
									:actualMin="value.actualMin"
									:actualMax="value.actualMax"
                                    fromDate=null
                                    toDate=null
									step=any
                                    @onChange="handleRange"
                                />
                            </template>
                            <template v-else>
                                <label v-for="(option, index) in  value.data" :key="`${index}-${value.name}-fieldData`">
                                    <span class="filter-selection--wrapper" v-if="value.hasRefData||value.valFmtFn">
                                        <input
											:id="option.name"
											class="filterCheckbox"
                                            type="checkbox" 
                                            :name="property" 
                                            :checked="option.selected" 
                                            :value="{
                                                field: property,
                                                value: option.id
                                            }"
                                            @change="toggleFilters"
                                        />
                                        <span class="filter-selection--label"> 
                                            {{option.name}}
                                        </span>
                                    </span>
                                    <span class="filter-selection--wrapper" v-else>
                                        <input
											:id="option.name"
											class="filterCheckbox"
                                            type="checkbox" 
                                            name="filter" 
                                            :checked="option.selected" 
                                            :value="{
                                                field: property,
                                                value: option.value
                                            }"
                                            @change="toggleFilters"
                                        />
                                        <span class="filter-selection--label"> 
                                            {{option.value}}
                                        </span>
                                    </span>
                                </label>
                            </template>
                        </div>
                    </filter-accordion>
				</div>
            </template>
            <b-dropdown-divider />
			<div>
            <button 
                class="btn-link" 
                @click="m_clearFilters" 
                title="Clear current filters"
				:disabled="!c_currentFilter"
            >
                <fa-icon icon="undo" />Clear Filters
            </button>
			<input id="removeCurrentFilter" type="checkbox"   class="deleteCheckbox border" v-model="d_removeCurrentFilter" :disabled="!c_currentFilter" />
			<span>Delete current filter</span>
			</div>
            <b-row class="d-flex flex-wrap align-items-center px-2 mt-2">
                <b-col class="w-50">
                    <input 
                        type="text"
                        class="w-100 border"
                        v-model="saveTemplateName" 
						:disabled="!c_currentFilter"
                        size="10"
                    />
                </b-col>
                <b-col class="w-50">
                    <button
                        class="btn-link w-100 p-0" 
                        @click="m_saveTemplate" 
						:disabled="!c_currentFilter"
                        title="Save current filter as a template"
                    >
                        <fa-icon icon="save" class="mr-1" />Save filter
                    </button>
                </b-col>
            </b-row>
            <b-row class="d-flex flex-wrap align-items-center px-2 pb-2 mt-2">
                <b-col class="w-50">
                    <select 
                        class="w-100 p-1 small border"
                        v-model="applySelectedTemplate"
                    >
                        <option>Select Filter</option>
                        <option 
                            v-for="(template, index) in templates" 
                            :key="`template-option-${index}`" 
                            :value="template.filter"
                        >
                            {{template.name | capitalizeFirstLetter}}
                        </option>
                    </select>
                </b-col>
                <b-col class="w-50">
                    <button 
                        class="btn-link w-100 p-0" 
                        title="Apply a filter template" 
						:disabled="!c_selectedFilter"
                        @click="m_applyTemplate"
                    >
                        <fa-icon icon="filter" class="mr-1" />Apply filter
                    </button>
                </b-col>
            </b-row>
        </b-dropdown>
    </div>
</template>

<script> 
    import FilterAccordion from './KT-FilterAccordion.vue';
    import FilterRange from './KT-FilterRange.vue';
    import SkeletonFilterComponent from './KT-SkeletonFilterComponent.vue';
	//import { eventBus } from '@/main';
    export default {
        name: 'filter-component',
        components: {
            "filter-accordion": FilterAccordion,
            "filter-range": FilterRange,
            "skeleton-filter" : SkeletonFilterComponent
        },
        props: {
            p_filterData: {type:Object,default:null},
            p_columns: {type:Array},
			p_tblId: String,
			p_filters:{type:Object,default: null},
        },
        data() {
            return {
                openFilter: false,
                d_activeFilters: {},
				d_filterFileNames: [],
                d_filters: [],
                saveTemplateName: '',
                templates: [],
                applySelectedTemplate: '',
				d_localStorageFilter:{},
				d_currentFilterName:null,
				d_removeCurrentFilter:null,
				d_disableDelete:false,
				d_showFilter:true,
				d_activeFilterCount:null,
				d_filterData:[],
				d_search:null,
				d_URLparams:null,
            }
        },
		created() {
			//this.m_setupFilters();
            
        },
        mounted() {	

			
			
            const removeTarget = (event) => {
                if (!(event.target == this.$refs.dropdown || this.$refs.dropdown?.contains(event.target))) 
                {
                    this.openFilter = false;
                }
            }
            window.addEventListener('click', removeTarget);
			
			//any local storage filter
			
			if(this.p_filters){
				console.log('In p_filters');
				this.d_activeFilters=this.p_filters;
				}
			else {
			this.d_localStorageFilter = JSON.parse(localStorage.getItem('localFilter'+this.p_tblId));
			console.log('In d_localStorageFilter');
			console.log(this.d_localStorageFilter);
			if(this.d_localStorageFilter){
				this.d_filters=this.d_localStorageFilter;
				this.d_activeFilters=this.d_localStorageFilter;
				this.$emit('filters', this.d_localStorageFilter);
				this.d_currentFilterName='localFilter'+this.p_tblId;					
				}
			}

			for(const key in this.p_filterData) {
				if(!this.p_filterData[key].range&&!this.p_filterData[key].date){
					this.p_filterData[key].data.forEach(d=>{
						var filter=this.d_activeFilters[key];
						var filterData=filter?.data;
						if(filterData?.length) d["selected"]=filterData.includes(d.id||d.value);
						});
					}
				}
				
            // Get save templates from local storage.
            const cacheData = JSON.parse(localStorage.getItem('filterTemplate'));

            if (cacheData) {
                this.templates = cacheData.filter(f=>f.table==this.p_tblId);
            }        
	},
        filters: {
            capitalizeFirstLetter(value) {
                if (!value) return '';
                value = value.split(' ').map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(' ');
                return value;
            }
        },
        computed: {
			c_filters(){ return this.d_filters.length > 0;},
			c_currentFilter() {	return (this.d_currentFilterName||(this.applySelectedTemplate&&this.applySelectedTemplate !== "Select Filter"));},
			c_selectedFilter() { return (this.applySelectedTemplate&&this.applySelectedTemplate !== "Select Filter");},					
			c_filterFileNames(){ return this.d_filterFileNames.length > 0;},
            isLoading() {
                let loading = true;
                const valueLength = this.p_filterData && Object.values(this.p_filterData).length;

                if (valueLength > 0) {
                    loading = false;
                }

                return loading;
            },
			c_filterData(){
				if(!this.d_search) return this.p_filterData;
				var sfilterData={...this.p_filterData};
				var filterData=JSON.parse(JSON.stringify(this.p_filterData));
				//var filterData={...this.p_filterData};
				var searchString=this.d_search;
				if(searchString.endsWith("|")) searchString=searchString.substr(0, searchString.length-1);
				var v_filterData={};
				var v_dataArray;
				var v_dataObj;
				var v_keyObj={};
				var v_firstDataObj;
				var v_dataKeys;
				var regex=new RegExp(searchString,'i');
				for(const key in filterData) 
					{
						v_keyObj=filterData[key];
						Object.keys(filterData[key]).forEach(k => {v_keyObj[k] = filterData[key][k];});
						//Json.parse not copying function so explicit copy.
						if(this.p_filterData[key].valFmtFn) v_keyObj['valFmtFn']=this.p_filterData[key].valFmtFn;
						if(!v_keyObj.date &&!v_keyObj.range&&v_keyObj.data.length){
							v_dataArray=v_keyObj.data;
							console.log(v_dataArray);
							v_firstDataObj=v_dataArray[0];
							v_dataKeys=Object.keys(v_firstDataObj);
							if(['oppr','proj','acct','extr','cmpt','team'].includes(v_keyObj.datatype))
								v_keyObj.data=[...v_dataArray.filter(d=>regex.test(d.value['name']))];
							else if(v_dataKeys.includes('name'))
								v_keyObj.data=[...v_dataArray.filter(d=>regex.test(d.name))];
							else if(v_dataKeys.includes('value'))
								v_keyObj.data=[...v_dataArray.filter(d=>regex.test(d.value))];
							else v_keyObj.data=[...v_dataArray.filter(d=>regex.test(d))];
						} 
						v_filterData[key]=v_keyObj;
						
					}
	
				return v_filterData;
			},
        },
		watch:{
			p_filterData(nv,ov){

			if(this.d_activeFilters){
				for(const key in this.p_filters) {
					if(this.p_filters[key].range||this.p_filters[key].date)
						if(this.p_filterData[key]){
							{this.p_filterData[key].min=this.p_filters[key].min;
							this.p_filterData[key].max=this.p_filters[key].max;
							}
						}
						else 
							if(this.p_filterData[key]){
								this.p_filterData[key].data.forEach(d=>{
								var filter=this.d_activeFilters[key];
								var filterData=filter?.data;
								if(filterData.length) d["selected"]=filterData.includes(d.id||d.value);
								});
								}
						}
								
				}
				
			
		},
		p_filters(nv){ 
					if(nv) this.d_activeFilters=nv;	else this.d_activeFilters={};
						
					for(const key in this.p_filters) {
					if(this.p_filters[key].range||this.p_filters[key].date)
						{this.p_filterData[key].min=this.p_filters[key].min;
						this.p_filterData[key].max=this.p_filters[key].max;
						}
						else 
							{this.p_filterData[key].data.forEach(d=>{
								var filter=this.d_activeFilters[key];
								var filterData=filter?.data;
								if(filterData.length) d["selected"]=filterData.includes(d.id||d.value);
							
							});
						}
								
					}
						
				},
	},
        methods: {
            m_setupFilters() {

                this.p_columns.forEach(col => {
                    if (col?.datatype === 'num') 
                        this.d_activeFilters[col.field] = {
							range:true,
                            min: 0,
                            max: 0,
							datatype:col.datatype
                        };
					else if (col?.datatype === 'date') 
                        this.d_activeFilters[col.field] = {
							date:true,
							datatype:col.datatype
                        };
                     else 
                        this.d_activeFilters[col.field] ={data:[], datatype:col.dataype};
                    
                });
            },
			m_closeWindow(){
				this.$emit('close',null);
				},
			m_clearFilters() {
                this.$emit('clearFilters', this.d_filters);
				
				////remove filter if requested
				if(this.d_removeCurrentFilter){ 
					const filterName=this.d_currentFilterName||this.applySelectedTemplate;
					if(filterName=='localFilter'+this.p_tblId){
						localStorage.setItem('localFilter'+this.p_tblId,null);
						this.d_currentFilterName=null;
					}	
					else { 	//remove current named filter
							const cacheData = JSON.parse(localStorage.getItem('filterTemplate'));
							const filterId=cacheData.findIndex(f => f.name == filterName&&f.table==this.p_tblId);
							cacheData.splice(filterId, 1);
							localStorage.setItem('filterTemplate', JSON.stringify(cacheData));
							this.templates = cacheData.filter(f=>f.table==this.p_tblId);
							this.applySelectedTemplate=null;
						}
				
				
				} else this.d_currentFilterName=null;
		
			
				for(const key in this.p_filters) {
					if(this.p_filters[key].range||this.p_filters[key].date)
						{this.p_filterData[key].min=this.p_filterData[key].actualMin;
						this.p_filterData[key].max=this.p_filterData[key].actualMax;
						}
						else 
							{this.p_filterData[key].data.forEach(d=>
							{d["selected"]=false;});
						}
								
				}
								
				$('.filterCheckbox:input:checkbox').each(function(){ this.checked = false;});
				
				
                this.m_setupFilters();
                // TODO: clear applySaveTemple
			},
			m_saveTemplate() {
                const cacheData = JSON.parse(localStorage.getItem('filterTemplate'));

                if (cacheData) {
                    const data = {
						table:this.p_tblId,
                        name: this.saveTemplateName,
                        filter: this.d_activeFilters
                    };

                    if (data.name !== '' && this.d_filters.length !== 0) {
                        cacheData?.push(data);
                        this.templates.push(data);
                        localStorage.setItem('filterTemplate', JSON.stringify(cacheData));
                        this.saveTemplateName = '';
                    }
                } else {
                    const data = {
						table:this.p_tblId,
                        name: this.saveTemplateName,
                        filter: this.d_activeFilters
                    };
                    
                    if (data.name !== '' && this.d_filters.length !== 0) {
                        this.templates.push(data);
                        localStorage.setItem('filterTemplate', JSON.stringify([data]));
                        this.saveTemplateName = '';
                    }
                }
            },
			m_applyTemplate() {
                const selectedTemplate = this.applySelectedTemplate;

                if (selectedTemplate !== "Select Filter") {
                    this.d_activeFilters = selectedTemplate;
                    this.$emit('filters', this.d_activeFilters);
					this.d_currentFilterName=selectedTemplate;
                }
				console.log(Array.from(document.querySelectorAll('input[type=checkbox]')));				
				Array.from(document.querySelectorAll('input[type=checkbox]')).forEach(el => 
				{ 
					if(el._value){
						var filterField=el._value.field;
						var filterValue=el._value.value;
						if(this.d_activeFilters[filterField].data.indexOf(filterValue)>-1) el.checked = true;
						}
				});
				
				//Save as local Storage Filter
				localStorage.setItem('localFilter'+this.p_tblId, JSON.stringify(this.d_activeFilters));
				
            },
			m_countActiveFilters(){
			// Count Active Filters.
				let filterCount=0;
				for (const key in this.d_activeFilters) {
				if(this.d_activeFilters[key]?.range){
					if(this.d_activeFilters[key].min>this.d_activeFilters[key].actualMin||
					this.d_activeFilters[key].max<this.d_activeFilters[key].actualMax)
					filterCount=filterCount+1;					
				}else{
				if(this.d_activeFilters[key]?.date){
				
					if((new Date(this.d_activeFilters[key].min)>new Date(this.d_activeFilters[key].actualMin))||
					(new Date(this.d_activeFilters[key].max)<new Date(this.d_activeFilters[key].actualMax))){
						filterCount=filterCount+1;
					}
				}else{
					if (this.d_activeFilters[key].data.length) filterCount=filterCount+1;

					}
				}
			}
			this.d_activeFilterCount=filterCount;
		},
            toggleFilter() {
                this.openFilter = !this.openFilter;
            },
            toggleFilters(data) {
			
                const {_value: {field, value}} = data.target;
				var col=this.p_columns.filter(c=>c.field==field)[0];
				var filter=this.d_activeFilters[field];
				var filterData=filter?.data;
				if(filter) {
					if(filterData?.length) {
						const fieldIndex = filterData.indexOf(value);
						if (fieldIndex !== -1) filterData.splice(fieldIndex, 1);
						else this.d_activeFilters[field].data.push(value);
						}
				} else {var values=[];
						values.push(value);
                        this.d_activeFilters[col.field] ={data:values,datatype:col.dataype};
						}
                this.$emit('filters', this.d_activeFilters);
				
				//Save as local Storage Filter
				localStorage.setItem('localFilter'+this.p_tblId, JSON.stringify(this.d_activeFilters));
				this.d_currentFilterName='localFilter'+this.p_tblId;
			
			this.m_countActiveFilters();
			if(this.d_activeFilterCount==0){
				this.d_currentFilterName=null;
				localStorage.removeItem('localFilter'+this.p_tblId);
				}

			//Reset selected options 
			this.p_filterData[field].data.forEach(d=>{
				var filter=this.d_activeFilters[field];
				var filterData=filter?.data;
				if(filterData.length) d["selected"]=filterData.includes(d.id||d.value);
			});
				
				
            },
            handleRange(data) {
                const {name, min, max, fromDate,toDate,actualMin,actualMax} = data;

                if (min || max) {
                    this.d_activeFilters[name] = {
                        range: true,
                        min: min,
                        max: max,
						actualMin:actualMin,
						actualMax:actualMax
                    };
                }
                
                if (fromDate || toDate) {
                    this.d_activeFilters[name] = {
                        date: true,
                        min: fromDate,
                        max: toDate,
						actualMin: actualMin,
						actualMax: actualMax
                    };
                }

                this.$emit('filters', this.d_activeFilters);
				//Save as local Storage Filter
				localStorage.setItem('localFilter'+this.p_tblId, JSON.stringify(this.d_activeFilters));
				this.d_currentFilterName='localFilter'+this.p_tblId;

			this.m_countActiveFilters();
			if(this.d_activeFilterCount==0){
				this.d_currentFilterName=null;
				localStorage.removeItem('localFilter'+this.p_tblId);
				}           
           
            }
        }
    }
</script>

<style>
    .table-filter {
        align-items: center;
        font-size: 14px;
        letter-spacing: 0.25px;
        background-color: #ffffff;
        //border: 1px solid #6c757d;
        //border-radius: .25rem;
		border:none !important;
        transition: 0.3s ease-in-out;
    }
    .table-filter:hover {
        background-color: #6c757d;
        color: #fff;
    }
    .table-filter.active, .table-filter[aria-expanded="true"] {
        background-color: #6c757d;
        color: #fff;
    }
    .table-filter .icon {
        width: 1.125rem;
    }
    .table-filter .icon svg {
        fill: #6c757d;
    }
    .table-filter:hover .icon svg {
        fill: #fff;
    }
    .table-filter.active .icon svg {
        fill: #fff
    }
    .filter-header {
        gap: 1rem;
    }
    .filter-dropdown.dropdown-menu {
        position: absolute;
        top: 0rem;
        right: 0rem;
        width: 275px;
        background-color: #fff;
        border: none !important;
        border-radius: 6px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
        overflow: hidden;
        transform: translate3d(-10px, 38px, 0px);
        will-change: transform;
        z-index: 20;
    }
    .btn.dropdown-toggle {
        margin: 0px
    }
    .filter-dropdown--header {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    .filter-dropdown--content {
        max-height: 300px;
        overflow-y: scroll;
    }
    .filter-selection--label {
        color: #4fa4ff;
    }
    .filter-dropdown--header .filter-dropdown--close {
        width: auto;
    }
    .filter-dropdown h3 {
        font-weight: bold;
        font-size: 1.15rem;
        padding: 1.25rem 1.25rem 0rem 1.25rem;
        margin-bottom: 0rem;
    }
    .filter-dropdown button:not(.filter-dropdown--close) {
        width: 100%;
    }
    .filter-dropdown button {
        font-size: 14px;
        font-weight: bold;
        padding: 1rem 1.25rem;
        border: none;
        background-color: transparent;
    }
    .filter-dropdown button.btn-link {
        padding: 0.5rem;
        text-align: left;
    }
    .filter-dropdown .icon {
        width: 1rem;
        margin-right: 0.5rem;
    }
    .filter-dropdown .expand {
        background-color: rgb(245, 245, 245);
        padding: 1.25rem;
    }
    .filter-dropdown input[type="search"] {
        width: 100%;
        padding: 0.5rem 1rem;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
        margin-bottom: 0.5rem;
    }
    .filter-selection {
        display: flex;
        flex-direction: column;
        padding: 0.5rem 0rem;
        gap: 0.5rem;
        height: 120px;
        overflow-y: scroll;
        scrollbar-width: auto;
        scrollbar-color: #4fa4ff #ffffff;
    }
    .filter-selection.range,
    .filter-selection.date {
        height: auto;
        overflow-y: hidden;
    }
    .filter-selection label {
        width: 100%;
        font-size: 14px;
        display: flex;
        align-items: center;
    }
    .filter-selection input {
        margin-right: 0.75rem;
    }
    .filter-selection--wrapper {
        display: flex;
    }
    .apply-filters {
        gap: 0.5rem;
    }
    .applied-filter {
        display: flex;
        gap:0.25rem;
        background-color: #b8d8fa;
        color: #05488e;
        padding: 0.2rem 0.5rem;
        border: 0px;
        border-radius: 50px;
        font-size: 12px;
    }

    .applied-filter .icon {
        width: 0.75rem;
    }
    .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        top: auto;
        left: -10000px;
        overflow: hidden;
    }

    .close-icon {
        width: 1.25rem;
        height: 1.25rem;
    }
    /* ===== Scrollbar CSS ===== */
    .filter-selection::-webkit-scrollbar, .filter-dropdown--content::-webkit-scrollbar {
        width: 6px;
    }

    .filter-selection::-webkit-scrollbar-track, .filter-dropdown--content::-webkit-scrollbar-track {
        background: #ffffff;
    }

    .filter-selection::-webkit-scrollbar-thumb, .filter-dropdown--content::-webkit-scrollbar-thumb {
        background-color: #4fa4ff;
        border-radius: 10px;
        border: 1px solid #ffffff;
    }

.btn-link {
	display:inline-block;
	//width: 100%;
	padding-bottom: 0.5em;
	text-align: left;
	}
.btn-100{
     width: 100%;
    }
hr {
    color: #ddd;
    background-color: #ddd;
    height: 1px;
    border: none;
    max-width: 100%;
}
div.form-group {
		min-width: 300px;
		//display: flex;
		flex-wrap: wrap;
		color: #4fa4ff;
		> label {
			min-width: 130px;
			margin: auto 0;
			color: #4fa4ff;
		}
     }
.input-value {
			margin-right: 0.3em;
			opacity: 0.5;
			&:hover {
			opacity: unset;
				}
			}
.btn2
		{
		font-size: 1em;
		margin-left: 0.5em;
		margin-right: 0.5em;
		padding: 0em 0.3em;
		border: solid 0.001em;
		border-radius: 0.15em;
		//opacity: 0.3;
			&:hover {
			opacity: unset;
				}
	}
h3 {
  text-align: center;
}
.filter-dropdown .topright-close {
  position: absolute;
  top: 2px;
  right: 8px;
  float: none;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  z-index: 2;
  background: transparent;
}
.filter-dropdown .topright-close:hover {color: green;}
svg.fa-check-circle {
				font-size: 0.8em;
				color: #28a745; 
				background-color: white; 
				&:hover {
					opacity: 0.8;
						}
	}
.deleteCheckbox {
   width: 5% !important;
}
</style>